
const criar = (vm) => {
  let doc = new vm.$JsPDF('l', 'pt')
  vm.entradas = vm.$utils.exportaPdf.trataEntrada(vm.entradas);
  vm.$utils.exportaPdf.adicionaLogos(doc, vm.nomeImagemParceiro)

  doc.setFontSize (14)
  doc.setFontType ("bold")
  doc.centerText ('Relatório (Comparativo Pasto - Simulação Avançada)', 50)

  // estilos
  let estiloColuna = {
    halign: 'right',
    textColor: 0,
    columnWidth: parseInt(550 / (vm.lista.length)),
    fontSize: 10,
    font: "helvetica",
  }

  let numeroPagina = 0;

  let options = {
    theme: 'striped',
    styles: {
      overflow: 'linebreak'
    },
    startY: 85,
    margin: {top: 30},
    drawCell: function (row, data) {
      if (row.text.length && row.text[0].replace(/[^0-9-]/g, '')) {
        let isComparativo = false;
        data.row.raw.forEach(el => {
          if (el.includes('comparativo')) isComparativo = true;
        })
        const text = row.text[0].replace(/[^0-9-]/g, '');
        if (isComparativo && text !== '-') {
          text.includes('-') ? doc.setTextColor('#FF3348') : doc.setTextColor('#54B07D');
        }
      }
    },
    addPageContent: function (data) {
      doc.setFontSize(10);
      if (numeroPagina !== doc.internal.getNumberOfPages()) {
        numeroPagina = doc.internal.getNumberOfPages()
        doc.text(40, 570, String(numeroPagina))
        doc.text(660, 570, 'Powered by Rancho Soluções');
      }
    },
    headerStyles: {
      fillColor: 255,
      textColor: 0,
      halign: 'right'
    },
    columnStyles:{
      0: {
        columnWidth: 200,
        fontStyle: 'bold',
        fillColor: [25, 150, 190],
        lineColor: [25, 150, 190],
        textColor: 255,
        fontSize: 10,
        font: "helvetica",
      },
      1: estiloColuna,
      2: estiloColuna,
      3: estiloColuna,
      4: estiloColuna,
      5: estiloColuna
    }
  }

  // CONSOLIDANDO DADOS
  let dados = []
  for(let indice in vm.entradas) {
    if(vm.entradas[indice].informacoes && vm.entradas[indice].informacoes.produtiva) {
      if(vm.entradas[indice].informacoes.produtiva.padraoRacial)
        vm.entradas[indice].informacoes.produtiva.padraoRacial = vm.entradas[indice].informacoes.produtiva.padraoRacial[0].label
      if(vm.entradas[indice].informacoes.produtiva.sexoAnimais)
        vm.entradas[indice].informacoes.produtiva.sexoAnimais = vm.entradas[indice].informacoes.produtiva.sexoAnimais.label
    }

    if(vm.entradas[indice].sistemaProducao && vm.entradas[indice].sistemaProducao[0] && vm.entradas[indice].sistemaProducao[0].label) {
      vm.entradas[indice].informacoes.produtiva.estagioNegocio = vm.entradas[indice].sistemaProducao[0].label
    }
  }
  vm.resultadosGerais.forEach((resultados, index) => {
    let dado = {
      resultados,
      entrada: vm.entradas[index]
    }
    dados.push(dado)
  });

  let tabelas = [
    {
      "titulo": "Informações Produtivas",
      "campos": [
        "entrada.nome",
        "entrada.informacoes.produtiva.estagioNegocio",
        "entrada.informacoes.produtiva.totalAnimaisLote",
        "entrada.informacoes.produtiva.racaAnimais",
        "entrada.informacoes.produtiva.padraoRacial",
        "entrada.informacoes.produtiva.sexoAnimais",
        "entrada.informacoes.produtiva.idadeEntradaMeses",
        "entrada.informacoes.produtiva.mortalidade",
        "entrada.informacoes.produtiva.cidade",
        "entrada.informacoes.produtiva.estado",
        "entrada.informacoes.produtiva.frigorifico",
        "entrada.informacoes.produtiva.rendimentoCarcacaEntrada",
        "entrada.informacoes.produtiva.rendimentoCaracaAbate",
        "entrada.informacoes.produtiva.uaMediaCiclo"
      ],
    },
    {
      "titulo": "Consolidação",
      "campos": [
        "entrada.informacoes.ciclo.consolidado.dataFinal",
        "entrada.informacoes.ciclo.consolidado.duracao",
        "entrada.informacoes.ciclo.consolidado.gmdKgd",
        "entrada.informacoes.ciclo.consolidado.gmdKgDComparativo",
        "entrada.informacoes.ciclo.consolidado.pesoInicial",
        "entrada.informacoes.ciclo.consolidado.pesoFinal",
        "entrada.informacoes.ciclo.consolidado.pesoMedio",
        "entrada.informacoes.ciclo.consolidado.consumoPV",
        "entrada.informacoes.ciclo.consolidado.consumoKG",
        "entrada.informacoes.ciclo.consolidado.preco",
        "entrada.informacoes.ciclo.consolidado.custo"
      ]
    },
    {
      "titulo": "Informações Financeiras",
      "campos": [
        "entrada.informacoes.financeira.valorGadoCabecaCIF",
        "entrada.informacoes.financeira.dataPagamentoGado",
        "entrada.informacoes.financeira.taxaRemuneracaoCapital",
        "entrada.informacoes.financeira.diasEntreEmbarqueAbate",
        "entrada.informacoes.financeira.diasEntreAbateRecebimento",
        "entrada.informacoes.financeira.diasExtrasRecebimento",
        "entrada.informacoes.financeira.precoReferenciaBoiGordo",
        "entrada.informacoes.financeira.custoVariavelExcetoNutricao",
        "entrada.informacoes.financeira.custoFixoTotal",
        "entrada.informacoes.financeira.despesasCabecasMes",
        "entrada.informacoes.financeira.despesasComercializacao",
        "entrada.informacoes.financeira.deducoesAplicadasROB",
        "resultados.economicos.dre.depreciacao",
        "resultados.economicos.dre.amortizacao",
        "resultados.economicos.dre.naoOperacional",
        "resultados.economicos.dre.valorImpostoRenda",
        "resultados.economicos.analise.principal.precoArrobaVendidaBruto",
        "entrada.informacoes.financeira.diferencialBase",
        "entrada.informacoes.financeira.descontoAplicadoVendaVista",
        "entrada.informacoes.financeira.premioEU",
        "entrada.informacoes.financeira.premioHilton",
        "entrada.informacoes.financeira.premioAngus",
        "entrada.informacoes.financeira.premioAcabamento",
        "entrada.informacoes.financeira.outrosPremios"
      ]
    },
    {
      "titulo": "Resultados Produtivos e Econômicos Principais",
      "campos": [
        "resultados.produtivos.pesoSaidaKg",
        "resultados.produtivos.pesoSaidaArroba",
        "resultados.produtivos.ganhoDePesoKG",
        "resultados.produtivos.quantidadeKGProduzidadaLote",
        "resultados.produtivos.ganhoDePesoArroba",
        "resultados.principais.dataAbate",
        "resultados.principais.taxaMensalCapitalInvestidoGado",
        "resultados.principais.lucroLiquido",
        "resultados.principais.lucroLiquidoCabComparativo",
        "resultados.economicos.analise.geral.dataLiquidacaoFinanceira",
        "resultados.economicos.analise.custo.custoArrobaEntradaMagra",
        "resultados.economicos.analise.custo.custoArrobaVendida",
        "resultados.economicos.analise.principal.precoArrobaVendidaLivre",
        "resultados.economicos.analise.custo.custeioMes",
        "resultados.area.principal.lucroLiquidoCicloProdutivo",
        "resultados.area.principal.lucroLiquidoCicloProdutivoComparativo",
        "resultados.area.principal.lucroLiquidoCicloAnualizado",
        "resultados.area.principal.lucroLiquidoCicloAnualizadoComparativo"
      ],
      "mesmaPagina": true
    },
    {
      "titulo": "Resultados Produtivos",
      "campos": [
        "resultados.produtivos.pesoEntradaKg",
        "resultados.produtivos.pesoSaidaKg",
        "resultados.produtivos.pesoVivoMedioDuranteCicloProdutivoKg",
        "resultados.produtivos.pesoVivoColocadoKg",
        "resultados.produtivos.pesoEntradaArroba",
        "resultados.produtivos.pesoSaidaArroba",
        "resultados.produtivos.gmdKgd",
        "resultados.produtivos.gmdKgDComparativo",
        "resultados.produtivos.ganhoCarcacaKgd",
        "resultados.produtivos.rendimentoGanho",
        "resultados.produtivos.diasParaGanhar1Arroba",
        "resultados.produtivos.quantidadeArrobaGanhasCabecaMes",
        "resultados.produtivos.idadeAbateMeses",
        "resultados.produtivos.pesoSaidaKgCarcacaQuente",
        "resultados.produtivos.quantidadeArrobaProduzidadaCabeca",
        "resultados.produtivos.quantidadeArrobaProduzidadaLote",
        "resultados.produtivos.quantidadeArrobaAbatidasLote",
        "resultados.produtivos.quantidadeContratosBmfProtecaoLote",
        "resultados.produtivos.mortesCabecas",
        "resultados.produtivos.cicloProdutivoMeses",
        "resultados.produtivos.cicloProdutivoDias",
        "resultados.produtivos.d1CicloProdutivo",
        "resultados.produtivos.dzCicloProdutivo",
        "resultados.produtivos.dataEmbarque",
        "resultados.produtivos.dataAbate"
      ],
      "mesmaPagina": false
    },
    {
      "texto": "Resultados Econômicos"
    },
    {
      "titulo": "Análise econômica geral",
      "campos": [
        "resultados.area.balanco.agio",
        "resultados.economicos.analise.geral.dataLiquidacaoFinanceira",
        "resultados.economicos.analise.geral.cicloFinanceiroMeses"
      ]
    },
    {
      "titulo": "Análise do custo de produção",
      "campos": [
        "resultados.economicos.analise.custo.custoNutricaoArrobaProduzida",
        "resultados.economicos.analise.custo.custoNutricaoPorArrobaProduzidaComparativo",
        "resultados.economicos.analise.custo.outrosCustosArrobaProduzida",
        "resultados.economicos.analise.custo.despesasArrobaProduzida",
        "resultados.economicos.analise.custo.custoArrobaProduzida",
        "resultados.economicos.analise.custo.custoArrobaEntradaMagra",
        "resultados.economicos.analise.custo.custoArrobaVendida",
        "resultados.economicos.analise.custo.custoAnimalVendidoInclusoImposto",
        "resultados.economicos.analise.custo.custeioDia",
        "resultados.economicos.analise.custo.custeioMes",
        "resultados.economicos.analise.custo.custeioTotal",
        "resultados.economicos.analise.custo.custoVariavelCusteio",
        "resultados.economicos.analise.custo.custoFixoCusteio",
        "resultados.economicos.analise.custo.custoVariavelNutricional",
        "resultados.economicos.analise.custo.custoVariavelNutricionalComparativo"
      ],
      "mesmaPagina": true
    },
    {
      "titulo": "Análise econômica principal",
      "campos": [
        "resultados.economicos.analise.principal.lucratividadeOperacao",
        "resultados.economicos.analise.principal.rentabilidadeOperacao",
        "resultados.economicos.analise.principal.taxaMinimaAtratividade",
        "resultados.economicos.analise.principal.margemEBITDA",
        "resultados.economicos.analise.principal.margemArrobaVendidaLivre",
        "resultados.economicos.analise.principal.precoArrobaVendidaLivre",
        "resultados.economicos.analise.principal.precoArrobaVendidaBruto"
      ],
      "mesmaPagina": true
    },
    {
      "titulo": "DRE do animal suplementado, sem considerar mortalidade",
      "campos": [
        "resultados.economicos.dre.receitaOperacionalBruta",
        "resultados.economicos.dre.deducoes",
        "resultados.economicos.dre.receitaOperacionalLiquida",
        "resultados.economicos.dre.custoProdutoVendido",
        "resultados.economicos.dre.lucroBruto",
        "resultados.economicos.dre.lucroBrutoCabComparativo",
        "resultados.economicos.dre.despesaTotal",
        "resultados.economicos.dre.ebitda",
        "resultados.economicos.dre.depreciacao",
        "resultados.economicos.dre.amortizacao",
        "resultados.economicos.dre.ebit",
        "resultados.economicos.dre.financeiro",
        "resultados.economicos.dre.naoOperacional",
        "resultados.economicos.dre.lucroAntesImpostoRenda",
        "resultados.economicos.dre.lucroAntesImpostoRendaComparativo",
        "resultados.economicos.dre.valorImpostoRenda",
        "resultados.economicos.dre.lucroLiquido",
        "resultados.economicos.dre.lucroLiquidoCabComparativo"
      ]
    },
    {
      "titulo": "Pontos de Equilíbrio",
      "campos": [
        "resultados.economicos.analise.breakeven.pontoEquilibrioArrobaVendidaBruto",
        "resultados.economicos.analise.breakeven.pontoEquilibrioValorGado",
        "resultados.economicos.analise.custo.pontoEquilibrioCusteio"
      ]
    },
    {
      "titulo": "Resultados por Área",
      "mesmaPagina": true,
      "campos": [
        "resultados.area.principal.lotacaoMediaCicloProdutivo",
        "resultados.area.principal.perfilPesoMedioAnimalUA",
        "resultados.area.principal.produtividadeArrobaCicloProdutivo",
        "resultados.area.principal.produtividadeArrobaCicloAnualizado",
        "resultados.area.principal.uaMedioCicloProdutivo",
        "resultados.area.principal.ebitdaCicloProdutivo",
        "resultados.area.principal.ebitdaCicloAnualizado",
        "resultados.area.principal.lucroLiquidoCicloProdutivo",
        "resultados.area.principal.lucroLiquidoCicloProdutivoComparativo",
        "resultados.area.principal.lucroLiquidoCicloAnualizado",
        "resultados.area.principal.lucroLiquidoCicloAnualizadoComparativo",
        "resultados.area.principal.lotacaoFase_1",
        "resultados.area.principal.lotacaoFase_2",
        "resultados.area.principal.lotacaoFase_3",
        "resultados.area.principal.lotacaoFase_4",
        "resultados.area.principal.lotacaoFase_5",
        "resultados.area.principal.lotacaoFase_6",
        "resultados.area.principal.lotacaoFase_7",
        "resultados.area.principal.lotacaoFase_8"
      ]
    },
    {
      "titulo": "Balanço de @/ha por ciclo produtivo (equivalente @ boi gordo)",
      "campos": [
        "resultados.area.balanco.producao",
        "resultados.area.balanco.custeio",
        "resultados.area.balanco.agio",
        "resultados.area.balanco.outrosDesembolsos",
        "resultados.area.balanco.margemLiquida"
      ],
      "mesmaPagina": true
    },
    {
      "titulo": "Análise de viabilidade do projeto, considerando as perdas com mortalidade",
      "mesmaPagina": false,
      "campos": [
        "resultados.economicos.analise.viabilidade.capitalInvestido",
        "resultados.economicos.analise.viabilidade.valorFuturoAplicacaoGado",
        "resultados.economicos.analise.viabilidade.valorFuturoAplicacaoFinanceira",
        "resultados.economicos.analise.viabilidade.diferencaAplicacaoGadoFinanceira",
        "resultados.economicos.analise.viabilidade.lucroLiquidoLote",
        "resultados.economicos.analise.viabilidade.lucroLiquidoLoteComparativo",
        "resultados.economicos.analise.viabilidade.lucroLiquidoCadaAnimalLote",
        "resultados.economicos.analise.viabilidade.lucroLiquidoCadaAnimalLoteComparativo",
        "resultados.economicos.analise.viabilidade.taxaInternaRetorno",
        "resultados.economicos.analise.viabilidade.valorPresenteLiquido",
        "resultados.economicos.analise.viabilidade.taxaMensalCapitalInvestidoGado",
        "resultados.economicos.analise.viabilidade.indiceLucratividade"
      ]
    }
  ]

  let py = 80
  let primeiro = true

  function _pegarDescricao ( val ) {
    return vm.pegarDescricao(val.split('.').pop())
  }

  function _configuraCampo (idCampo, valor) {
    idCampo = idCampo.split('.').pop()
    for(let descricaoIndex in vm.descricoes.items){
      if(descricaoIndex == idCampo) {
        if(vm.descricoes.items[descricaoIndex].prefixo != null) {
          valor = vm.descricoes.items[descricaoIndex].prefixo+" "+valor
        }
        if(vm.descricoes.items[descricaoIndex].sufixo != null) {
          valor += " "+vm.descricoes.items[descricaoIndex].sufixo
        }
        return valor
      }
    }
    return valor || Number(valor) === 0 ? valor : 'Não Avaliado'
  }

  tabelas.forEach( item => {

    if (item.texto) {
      doc.setFontSize (14)
      doc.setFontType ("bold")
      doc.addPage()
      doc.centerText (item.texto, 40)
      doc.setFontType ("normal")
      doc.setFontSize (9)
      doc.setTextColor(230,230,231)
      doc.centerText ('_________________________________________________', 45);
      primeiro = true
      py = 65
    } else {
      const colunaNames = vm.entradas.map(el => el.nome);
      let tabela = vm.$utils.exportaPdf.geraTabela(dados, item.campos, _pegarDescricao, _configuraCampo, colunaNames)
      if (item.mesmaPagina) {
        py = doc.autoTable.previous.finalY + 25
      }
      addTab(doc, item.titulo, py, tabela, options, item.mesmaPagina || primeiro)
      primeiro = false
      py = 0
    }

  })

  return doc

}

const addTab = (doc, titulo, py, tabela, options, mesmaPagina) => {
  if (!mesmaPagina) doc.addPage()
  let tabPy = 35 + py
  doc.setFontSize (14)
  doc.setFontType ("bold")
  doc.setTextColor(0)
  doc.centerText(titulo, tabPy);
  doc.setFontType ("normal")
  doc.setFontSize (9)
  doc.setTextColor(230,230,231)
  doc.centerText ('_________________________________________________', tabPy + 5);
  options.startY = tabPy + 25;
  doc.autoTable(tabela.colunas, tabela.linhas, options);
}


export default {
  criar
}



// WEBPACK FOOTER //
// ./src/services/relatorio/comparativo/pasto/avancado.js